import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  wrapBox: {
    marginTop: 24,
    padding: 24,
    border: `1px solid ${Colors.Grey2}`,
    boxShadow: '0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)',
    background: Colors.White,
    '&:first-child': {
      marginTop: 0,
    },
  },
}));

export default useStyles;
